

export function getBiayaRegistrasi(level) {
    let gross_amount = 0;
    if (level === "distributor") {

        gross_amount = 1000000;

    } else if (level === "agen") {

        gross_amount = 500000;

    } else if (level === "reseller") {

        gross_amount = 150000;

    }

    return gross_amount
}